// import component from "./Drug"
import component from "./OurTechnology"

export default { 
    component,
    urlHash: "#technology",
    mobile: component,
}